import React from "react";
import ReactApexChart from "react-apexcharts";

const buildOptions = inputData => {
  const categories = inputData?.xAxis || [];
  return {
    chart: {
      type: "line",
      toolbar: { show: false },
      animations: { enabled: true }
    },
    legend: { show: true },
    colors: ["#001A53"],
    dataLabels: {
      enabled: true,
      background: { enabled: false },
      offsetY: -6,
      formatter: value => (value == null ? "" : `${value}`)
    },
    stroke: {
      curve: "smooth",
      width: 2
    },
    markers: {
      size: 3
    },
    xaxis: {
      categories,
      axisBorder: { show: true },
      axisTicks: { show: true },
      labels: { trim: false }
    },
    yaxis: {
      labels: {
        style: {},
        offsetX: 0,
        offsetY: 0
      }
    },
    grid: { strokeDashArray: 4 }
  };
};

const buildSeries = inputData => {
  const yValues = inputData?.yAxis || [];
  return [
    { name: "Mis 24", data: yValues }
  ];
};

export function Mis24({ data }) {
  const options = buildOptions(data || {});
  const series = buildSeries(data || {});
  return (
    <div className="mis-map">
      <ReactApexChart options={options} series={series} type="line" height="100%" width="100%" />
    </div>
  );
}
